import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Currency} from "../../currency-format/currency-format.typings";
import {CurrencyComponent} from "../../currency.component";
import {LoadService} from "../../../../services/load-service/load.service";
import {CurrencyApiService} from "../../../../services/currency.service";
import {ToasterService} from "angular2-toaster";
import {CountryInterface} from "../../../../interfaces/country.interface";


@Component({
    selector: 'app-create-edit-currency',
    templateUrl: './create-edit-currency.component.html',
    styleUrls: ['./create-edit-currency.component.scss']
})
export class CreateEditCurrencyComponent implements OnInit {

    createEditCurrency: Currency;
    validForm;
    currency: Currency;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {currency: Currency , countries:CountryInterface[]},
        public dialogo: MatDialogRef<CurrencyComponent>,
        // tslint:disable-next-line:variable-name
        private readonly _loadService: LoadService,
        // tslint:disable-next-line:variable-name
        private readonly _currencyService: CurrencyApiService,
        // tslint:disable-next-line:variable-name
        private readonly _toasterService: ToasterService,
    ) { }

    ngOnInit() {
    }
    validarFormulario(currency) {
        if (currency) {
            this.createEditCurrency = currency;
            this.validForm = true;
        } else {
            this.validForm = false;
        }
    }

    createEditMethod() {
        this._loadService.enableLoad();
        if (this.data.currency) {
            this._currencyService
                .updateCurrency(this.createEditCurrency)
                .subscribe(
                    async r => {
                        this._loadService.disableLoad();
                        this.dialogo.close(this.createEditCurrency);
                    },
                    err => {
                        this._loadService.disableLoad();
                        console.error(err);
                    },
                );
        } else {
            this.currency = {
                ...this.createEditCurrency,
            };
            this._currencyService
                .createCurrency(this.currency)
                .subscribe(
                    r => {
                        this._loadService.disableLoad();
                        this.dialogo.close(r);
                    },
                    err => {
                        this._loadService.disableLoad();
                        console.error(err);
                    },
                );
        }
    }

}
